import styled from "styled-components";

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-image: url(${({ theme }) => theme.backgroundsImages.default});
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 50px;
  min-height: 100vh;
  width: 100%;
  gap: 4rem;

  section {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    gap: 2rem;
  }

  footer {
    display: flex;
    align-items: center;
    justify-content: center;
    filter: drop-shadow(0px -4px 4px rgba(0, 0, 0, 0.25));
    background: ${({ theme }) => theme.backgrounds.defaultGradient};
    height: 5rem;

    .btnInitDemo {
      display: flex;
      align-items: center;
      text-decoration: none;
      justify-content: center;
      border: 2px solid ${({ theme }) => theme.colors.primary};
      line-height: 1.75rem;
      border-radius: 34px;
      font-size: 1.25rem;
      font-weight: 500;
      background: none;
      width: 17rem;
      height: 3rem;
      color: ${({ theme }) => theme.colors.primary};
      margin: 1rem;
    }

    .btnInitDemo:hover {
      background: #000;
      color: #fff;
    }
  }

  @media (max-width: 1075px) {
    section {
      flex-direction: column;
      align-items: center;
    }
  }

  @media (max-width: 425px) {
    footer {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 10rem;
    }
  }
`;

export const ContentText = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};

  h1 {
    font-size: 3.625rem;
    line-height: 120%;
    letter-spacing: -0.5px;
    color: ${({ theme }) => theme.black[900]};
    margin-bottom: 2.5rem;
  }

  p {
    font-size: 1.25rem;
    font-weight: 400;
    line-height: 1.25rem;
    font-family: ${({ theme }) => theme.typography.fontFamily.primary};
    margin-bottom: 1.5rem;
  }

  .box {
    font-family: ${({ theme }) => theme.typography.fontFamily.primary};
    background-color: #424242;
    line-height: 1.25rem;
    margin-left: 0.5rem;
    position: relative;
    border-radius: 5px;
    margin-bottom: 0;
    font-size: 1rem;
    color: #ffffff;
    margin-left: 0;
    padding: 1rem;
    float: left;
    gap: 0;

    .textFooter {
      font-size: 1rem;
    }

    @media (max-width: 425px) {
      width: 100%;
    }
  }

  .box.arrow-right:after {
    content: "";
    position: absolute;
    right: -15px;
    top: 40px;
    border-top: 15px solid transparent;
    border-right: none;
    border-left: 15px solid #424242;
    border-bottom: 15px solid transparent;

    @media (max-width: 768px) {
      display: none;
    }
  }

  ul {
    list-style: none;
  }

  li {
    display: flex;
    align-items: center;
    font-size: 1.25rem;
    font-weight: 600;
    line-height: 1.5rem;
    font-family: ${({ theme }) => theme.typography.fontFamily.primary};
    margin-bottom: 1.5rem;
    margin-left: 1rem;

    span {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 2rem;
      height: 2rem;
      background: ${({ theme }) => theme.backgrounds.defaultGradient};
      color: ${({ theme }) => theme.colors.primary};
      border-radius: 50%;
      margin-right: 0.5rem;
    }
  }

  @media (max-width: 425px) {
    padding: 0 1rem;
    h1 {
      font-size: 2.5rem;
    }

    ul li {
      font-size: 1rem;
    }
    ul li span {
      display: none;
    }
  }
`;

export const ContentInfo = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.backgrounds.defaultGradient};
  font-family: ${({ theme }) => theme.typography.fontFamily.secondary};
  color: ${({ theme }) => theme.colors.primary};
  border-radius: 5px;
  width: max-content;
  max-width: 20rem;
  padding: 1rem;
  height: 100%;
  min-height: 645px;
  gap: 0.5rem;

  @media (max-width: 1075px) {
    min-height: max-content;
  }

  .qrcode {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 5px;
    padding: 1rem;
    width: 100%;
  }

  p {
    text-align: center;
    margin-bottom: 1rem;
  }

  a {
    margin-bottom: 0.5rem;
  }

  h4 {
    margin-top: 2rem;
  }

  ul {
    margin-left: 2rem;
  }

  img {
    width: 100%;
  }

  .btnDeepLink {
    display: flex;
    place-self: center;
    text-decoration: none;
    border-radius: 5px;
    background: #000;
    width: 100%;

    a {
      text-decoration: none;
      font-size: 1.25rem;
      padding: 0.75rem;
      margin: 0;
      color: #fff;
    }
  }
`;
